import { NgFor, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, Input } from '@angular/core';
import { SkeletonComponent } from '@shared/components/skeleton/skeleton.component';
import { SearchBoxService } from '@shared/services/serach-box.service';
import { SharedModule } from '@shared/shared.module';

@Component({
  selector: 'iho-plp-cards-skeleton',
  standalone: true,
  imports: [NgIf, NgFor, SkeletonComponent,SharedModule],
  templateUrl: './plp-cards-skeleton.component.html',
  styleUrls: ['./plp-cards-skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlpCardsSkeletonComponent {
  searchBoxService = inject(SearchBoxService);

 accommodation = computed(() => this.searchBoxService.accommodation());

  @Input() count: number = 10
}
